var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 663,
    height: 891,
    viewBox: "0 0 663 891",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8333 691H18.1667C15.8655 691 14 692.865 14 695.167V736.833C14 739.135 15.8655 741 18.1667 741H59.8333C62.1346 741 64 739.135 64 736.833V695.167C64 692.865 62.1346 691 59.8333 691Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6669 714.611C34.5022 714.611 37.6114 711.502 37.6114 707.667C37.6114 703.832 34.5022 700.722 30.6669 700.722C26.8316 700.722 23.7225 703.832 23.7225 707.667C23.7225 711.502 26.8316 714.611 30.6669 714.611Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 732.666L48.7222 718.778L34.8333 731.278L25.1111 722.944L14 731.278",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.909 180.833H112.727C111.221 180.833 110 181.953 110 183.333V228.333C110 229.714 111.221 230.833 112.727 230.833H150.909C152.415 230.833 153.636 229.714 153.636 228.333V183.333C153.636 181.953 152.415 180.833 150.909 180.833Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.909 213.333H140",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.909 220.833H130.455",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140 190.833H120.909V203.333H140V190.833Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M552 844.412L555.947 848.824L563.842 840",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M552 865L555.947 869.412L563.842 860.588",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M552 885.588L555.947 890L563.842 881.177",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M573.053 865H602",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M573.053 885.588H602",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M573.053 844.412H602",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M585.128 171.361L606.855 191.826C607.603 192.531 607.977 192.884 608.418 192.971C608.617 193.01 608.821 193.01 609.02 192.971C609.461 192.884 609.836 192.531 610.584 191.826L632.311 171.361C638.424 165.603 639.166 156.127 634.025 149.482L633.058 148.233C626.908 140.284 614.562 141.617 610.24 150.697C609.63 151.979 607.809 151.979 607.198 150.697C602.877 141.617 590.531 140.284 584.38 148.233L583.414 149.482C578.272 156.127 579.015 165.603 585.128 171.361Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.483 447.782C33.7955 447.782 38.1021 443.578 38.1021 438.391C38.1021 433.205 33.7955 429 28.483 429C23.1706 429 18.864 433.205 18.864 438.391C18.864 443.578 23.1706 447.782 28.483 447.782Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 478.639C1 466.784 12.0742 457.173 25.7347 457.173",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2011 458.412C49.2011 459.818 49.2011 464.294 49.2011 464.294H37.1509C37.1509 464.294 37.1509 461.66 37.1509 458.412C37.1509 455.163 39.8485 452.529 43.176 452.529C46.5035 452.529 49.2011 455.163 49.2011 458.412Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.134 464.294H53.2177V479H33.134V464.294Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.607 51C401.749 51 413.214 39.8071 413.214 26C413.214 12.1929 401.749 1 387.607 1C373.465 1 362 12.1929 362 26C362 39.8071 373.465 51 387.607 51Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M362 26H413.214",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.607 51C393.264 51 397.85 39.8071 397.85 26C397.85 12.1929 393.264 1 387.607 1C381.95 1 377.364 12.1929 377.364 26C377.364 39.8071 381.95 51 387.607 51Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M369.5 8.67761C374.134 13.2017 380.536 16 387.607 16C394.678 16 401.08 13.2017 405.714 8.67761",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M405.714 43.3224C401.08 38.7982 394.678 36 387.607 36C380.536 36 374.134 38.7982 369.5 43.3224",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M607.327 372.638L607.995 372.979L607.327 372.638ZM607.769 421.094L607.237 420.565H607.237L607.769 421.094ZM659.629 410.64L659.97 411.308H659.97L659.629 410.64ZM660.94 409.329L660.272 408.988L660.94 409.329ZM660.94 372.638L661.609 372.298V372.298L660.94 372.638ZM659.629 371.327L659.97 370.659V370.659L659.629 371.327ZM608.638 371.327L608.979 371.995L608.638 371.327ZM617.56 411.261L617.029 410.732L617.56 411.261ZM607.75 375.8C607.75 374.948 607.751 374.353 607.788 373.891C607.825 373.437 607.895 373.176 607.995 372.979L606.659 372.298C606.432 372.742 606.338 373.222 606.293 373.769C606.249 374.306 606.25 374.972 606.25 375.8H607.75ZM607.75 392.8V375.8H606.25V392.8H607.75ZM606.25 392.8V410.967H607.75V392.8H606.25ZM606.25 410.967V410.967H607.75V410.967H606.25ZM606.25 410.967V420.777H607.75V410.967H606.25ZM606.25 420.777C606.25 421.847 607.545 422.382 608.3 421.624L607.237 420.565C607.426 420.376 607.75 420.509 607.75 420.777H606.25ZM608.3 421.624L618.092 411.79L617.029 410.732L607.237 420.565L608.3 421.624ZM656.467 410.217H618.269V411.717H656.467V410.217ZM659.289 409.972C659.091 410.072 658.831 410.141 658.377 410.178C657.914 410.216 657.32 410.217 656.467 410.217V411.717C657.295 411.717 657.961 411.717 658.499 411.673C659.046 411.629 659.526 411.534 659.97 411.308L659.289 409.972ZM660.272 408.988C660.056 409.412 659.712 409.756 659.289 409.972L659.97 411.308C660.675 410.949 661.249 410.375 661.609 409.669L660.272 408.988ZM660.517 406.167C660.517 407.019 660.517 407.613 660.479 408.076C660.442 408.53 660.373 408.791 660.272 408.988L661.609 409.669C661.835 409.225 661.929 408.745 661.974 408.198C662.018 407.66 662.017 406.994 662.017 406.167H660.517ZM660.517 375.8V406.167H662.017V375.8H660.517ZM660.272 372.979C660.373 373.176 660.442 373.437 660.479 373.891C660.517 374.353 660.517 374.948 660.517 375.8H662.017C662.017 374.972 662.018 374.306 661.974 373.769C661.929 373.222 661.835 372.742 661.609 372.298L660.272 372.979ZM659.289 371.995C659.712 372.211 660.056 372.555 660.272 372.979L661.609 372.298C661.249 371.592 660.675 371.018 659.97 370.659L659.289 371.995ZM656.467 371.75C657.32 371.75 657.914 371.751 658.377 371.788C658.831 371.825 659.091 371.895 659.289 371.995L659.97 370.659C659.526 370.432 659.046 370.338 658.499 370.293C657.961 370.249 657.295 370.25 656.467 370.25V371.75ZM611.8 371.75H656.467V370.25H611.8V371.75ZM608.979 371.995C609.176 371.895 609.437 371.825 609.891 371.788C610.353 371.751 610.948 371.75 611.8 371.75V370.25C610.972 370.25 610.306 370.249 609.769 370.293C609.222 370.338 608.742 370.432 608.298 370.659L608.979 371.995ZM607.995 372.979C608.211 372.555 608.555 372.211 608.979 371.995L608.298 370.659C607.592 371.018 607.018 371.592 606.659 372.298L607.995 372.979ZM618.092 411.79C618.139 411.743 618.202 411.717 618.269 411.717V410.217C617.803 410.217 617.357 410.402 617.029 410.732L618.092 411.79Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M621.471 385.533L646.796 385.533",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M621.471 396.434L639.561 396.434",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M621.5 619.5C625.642 619.5 629 616.142 629 612C629 607.858 625.642 604.5 621.5 604.5C617.358 604.5 614 607.858 614 612C614 616.142 617.358 619.5 621.5 619.5Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M591.5 637C595.642 637 599 633.642 599 629.5C599 625.358 595.642 622 591.5 622C587.358 622 584 625.358 584 629.5C584 633.642 587.358 637 591.5 637Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M621.5 654.5C625.642 654.5 629 651.142 629 647C629 642.858 625.642 639.5 621.5 639.5C617.358 639.5 614 642.858 614 647C614 651.142 617.358 654.5 621.5 654.5Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M597.975 633.275L615.05 643.225",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M615.025 615.775L597.975 625.725",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 335.375,
    y: 681,
    width: 0.9375,
    height: 20,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 690.375,
    width: 20,
    height: 0.9375,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.375,
    y: 791,
    width: 0.9375,
    height: 20,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 800.375,
    width: 20,
    height: 0.9375,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 332.375,
    y: 141,
    width: 0.9375,
    height: 20,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 150.375,
    width: 20,
    height: 0.9375,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.375,
    y: 292,
    width: 0.9375,
    height: 20,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 301.375,
    width: 20,
    height: 0.9375,
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.fbf4570ebe2da721fd831da2f76e8e21.svg";
export { ForwardRef as ReactComponent };